import request from "./http";
import qs from 'qs'

// 	 * 单位产能->获取单位设备映射列表  unitNo 单位编号
export function getMappingList(params) {
    return request({
        url: "/capacity/mapping/list",
        method: "get",
        params
      
    });
}


// 	 * 单位产能->新增单位设备映射信息
//  capacityName 映射名称
//  localDevice 本地设备名称
//  localDeviceNo 本地设备编号
//  remotDevice 远程设备

export function setMappingSave(params) {
    return request({
        url: "/capacity/mapping/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

// 	 * 单位产能->修改单位设备映射信息
//  capacityName 映射名称
//  localDevice 本地设备名称
//  localDeviceNo 本地设备编号
//  remotDevice 远程设备
//  id  模板id

export function mappingUpdate(params) {
    return request({
        url: "/capacity/mapping/update",
        method: "put",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

// 	 * 单位产能->启用-禁用
//  dateStatus 状态:【ENABLE】-启用,【DISABLE】-禁用,可用值:ENABLE,DISABLE
//  id  模板id

export function mappingStatus(params) {
    return request({
        url: "/capacity/mapping/status",
        method: "put",
        params
    });
}

// 	 * 单位产能->查询产能报告
//  dateType 日期类型,可用值:YEAR,MON,DAY
//  mappingId  映射表id
//  requestTime  查询日期

export function capacityFindReport(params) {
    return request({
        url: "/capacity/findReport",
        method: "get",
        params
    });
}


// 	 * 单品能耗->根据单位id获取远程接口地址信息
export function capacityFindById(params) {
    return request({
        url: "/capacity/remote/findById",
        method: "get",
        params
    });
}

// 	 * 单品能耗->根据单位id获取远程接口地址信息
export function capacitySaveRemote(params) {
    return request({
        url: "/capacity/remote/save",
        method: "post",
        data:params
    });
}

// 	 * 单品能耗->启用-禁用远程接口地址
export function capacityStatusRemote(params) {
    return request({
        url: "/capacity/remote/status",
        method: "put",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}



// 	 * 单品能耗->产能管理->根据映射id和期间查询产能列表
export function recordFindList(params) {
    return request({
        url: "/capacity/record/findList",
        method: "get",
        params
    });
}


// 	 * 单品能耗->产能管理->产能修正
export function recordUpdateValue(params) {
    return request({
        url: "/capacity/record/updateValue",
        method: "put",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}


// 	 *单品能耗->产能管理->手工新增日产能
export function recordSave(params) {
    return request({
        url: "/capacity/record/save",
        method: "post",
        data:params
    });
}

// 	 *单品能耗->产能管理->修改产能日期及产量
export function recordUpdateInfo(params) {
    return request({
        url: "/capacity/record/updateInfo",
        method: "put",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}






